import React, { useEffect, useState } from "react";
import axios from "axios";

const CountryRepByNationality = () => {
  const [countryData, setCountryData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const token = JSON.parse(localStorage.user || "{}")?.access_token;
      const res = await axios.get(
        `${window.$domain}/api/method/get_country_rep_nationality_stats`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCountryData(res.data.message || []);
    } catch (err) {
      console.error("Failed to load nationality stats", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const maxValue = Math.max(...countryData.map((d) => d.total || 0), 1);

  return (
    <div className="bg-white rounded-2xl shadow p-6">
      <h2 className="text-xl font-semibold mb-4">
        Global Spread of Country Representatives
      </h2>

      {loading ? (
        <div className="text-gray-500 text-sm animate-pulse">Loading...</div>
      ) : countryData.length ? (
        <div className="space-y-3 max-h-[500px] overflow-y-auto pr-2">
          {countryData.map((entry, idx) => (
            <div key={idx} className="flex items-center justify-between gap-4">
              <span className="text-sm text-gray-700 w-32 truncate">
                {entry.country || "Unknown"}
              </span>
              <div className="flex-1 h-4 bg-gray-100 rounded overflow-hidden">
                <div
                  className="h-full bg-indigo-500 rounded"
                  style={{
                    width: `${(entry.total / maxValue) * 100}%`,
                  }}
                />
              </div>
              <span className="text-sm font-medium text-gray-900 w-6 text-right">
                {entry.total}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-gray-400 text-sm italic">No data available</div>
      )}
    </div>
  );
};

export default CountryRepByNationality;
